'use client';

import { type InputProps, Field as ChakraField, Input } from '@chakra-ui/react';
import type { Control, FieldErrors, UseFormRegister } from 'react-hook-form';
import { type FieldProps, Field } from './field';

interface FormInputProps
  extends InputProps, Omit<FieldProps, keyof InputProps> {
  label: string;
  id: string;
  register: UseFormRegister<any>;
  control: Control<any>;
  errors: FieldErrors;
  showLabelAtTop?: boolean;
}

const FormInput: React.FC<FormInputProps> = ({
  label,
  id,
  register,
  control,
  errors,
  disabled,
  helperText,
  isShowLabel = true,
  disableLabel = false,
  labelProps,
  showLabelAtTop = false,
  required = false,
  optionalText,
  ...rest
}) => {
  return (
    <Field
      label={!showLabelAtTop && label}
      invalid={!!errors?.[id]}
      id={id}
      errorText={errors?.[id]?.message as string}
      disabled={disabled}
      helperText={helperText}
      isShowLabel={isShowLabel}
      disableLabel={disableLabel}
      labelProps={labelProps}
      required={required}
      optionalText={optionalText}
    >
      {showLabelAtTop && label && (
        <ChakraField.Label mb={2} color="tertiary.fg">
          {label} <ChakraField.RequiredIndicator fallback={optionalText} />
        </ChakraField.Label>
      )}
      <Input
        id={id}
        {...register(id)}
        name={id}
        placeholder={`Enter ${label || id}`}
        disabled={disabled}
        {...rest}
      />
    </Field>
  );
};

export default FormInput;
